module.exports = __webpack_public_path__ + "img/tampa_scout.904f5ef4.gif";